// src/app/lib/constants.ts
// Voucher Type Codes
export const VOUCHER_CODE_SALES_INVOICE = "SINV";
export const VOUCHER_CODE_PURCHASE_INVOICE = "PINV";
export const VOUCHER_CODE_PAYMENT_MADE = "PMT";
export const VOUCHER_CODE_PAYMENT_RECEIVED = "RCT";
export const VOUCHER_CODE_CREDIT_NOTE = "CNOT"; // Sales Return
export const VOUCHER_CODE_DEBIT_NOTE = "DNOT"; // Purchase Return
export const VOUCHER_CODE_JOURNAL = "JV";
export const VOUCHER_CODE_STOCK_ADJUSTMENT = "STKADJ"; 